import React from 'react';
import { Route, IndexRoute } from 'react-router';
import GuestControl from './guestControl';

export default (
  <Route path="configuracoes">
    <Route path="controle-de-convidados">
      <IndexRoute component={(props) => <GuestControl {...props} />} />
    </Route>
  </Route>
);
